module.exports = __webpack_public_path__ + "img/paper_logo.1908caa0.jpg";